import {FC} from 'react'
import find from 'lodash/find'
import {orderStatusList} from 'app/features/orders/models'

type Props = {
  status: String
}

const FulfillmentStatus: FC<Props> = ({status}) => {
  const obj = find(orderStatusList, {id: status?.toLowerCase()})
  return obj ? <span className={`badge ${obj.color}`}>{obj.name}</span> : null
}

export default FulfillmentStatus
